import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaBars } from 'react-icons/fa'; // Import the hamburger icon

const navbar = [
  { id: 1, title: 'Home', link: '/' },
  { id: 2, title: 'FX Exchange', link: 'fXexchange' },
  { id: 3, title: 'FX News', link: 'fXnews' },
  { id: 4, title: 'About', link: 'about' },
  { id: 5, title: 'Contact Us', link: 'contactus' },
];
function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  function handleCloseMenu() {
    setIsOpen(false);
  }

  return (
    <div className='w-full drop-shadow-sm bg-p-wh'>
      <nav className='flex flex-col md:flex-row justify-between max-w-[1440px] items-center  px-4 sm:px-10 md:px-20 w-full my-4 font-semibold py-3 mx-auto'>
        <div className='flex items-center justify-between w-full lg:w-auto lg:mr-20 '>
          <Link to='/' className='text-b-mc font-semibold'>
            Loyaltyview
          </Link>
          <FaBars
            className='block lg:hidden'
            onClick={() => setIsOpen(!isOpen)}
          />{' '}
        </div>

        <div
          className={`w-full lg:flex lg:justify-between lg:static absolute top-10 lg:top-0 left-0 ${
            isOpen
              ? 'flex-col bg-white py-6 justify-start items-center'
              : 'hidden'
          } `}
        >
          <div className='flex flex-col lg:flex-row gap-2 justify-center items-center shrink-0 uppercase lg:capitalize'>
            {navbar.map((item) => {
              return (
                <NavLink
                  to={item.link}
                  key={item.id}
                  className={({ isActive }) =>
                    isActive ? 'py-2 px-4 text-b-mc' : 'py-2 px-4'
                  }
                  onClick={handleCloseMenu}
                >
                  {item.title}
                </NavLink>
              );
            })}
          </div>
          <div className='flex flex-col lg:flex-row gap-2 justify-center items-center shrink-0 uppercase lg:capitalize mt-4 lg:mt-0'>
            <Link
              to='signin'
              className='py-2 px-4  hover:text-b-mc/75 focus:text-b-mc/80'
              onClick={handleCloseMenu}
            >
              Sign In
            </Link>
            <Link
              to='signup'
              className='bg-b-mc text-p-wh py-2 px-4 rounded-lg'
              onClick={handleCloseMenu}
            >
              Sign Up
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}
export default NavBar;
